import { showSkeletons, clearSkeletons } from '@components/skeletons/articleSummaryCardSkeleton';
import {
  distinctUntilChanged,
  filter,
  map,
  withLatestFrom,
} from 'rxjs';
import { store$ } from '@redux/store';
import {
  selectPageSize,
  onSuccesedArticleSearchResults$,
  onloadingArticleSearchResults$,
} from 'features/articleSearchResultsFacets';

const LISTING_CONTAINER_SELECTOR = '[data-author-article-list]';

/**
 * Stream that emits the current page size,
 * only when it actually changes.
 */
const pageSize$ = store$.pipe(
  map(selectPageSize),
  filter(Boolean),
  distinctUntilChanged()
);

/**
 * Emits when search results start loading,
 * enriched with the latest pageSize.
 */
const renderSkeletons$ = onloadingArticleSearchResults$.pipe(
  withLatestFrom(pageSize$),
  map(([, pageSize]) => pageSize)
);

/**
 * Shows the article card skeletons while we fetch a new page.
 * The number of skeletons is always derived from pageSize.
 */
function renderBlogArticleCardSkeletons(pageSize) {
  const container = document.querySelector(LISTING_CONTAINER_SELECTOR);
  if (!container) {
    return;
  }

  container.removeAttribute('hidden');
  showSkeletons(container, pageSize);
}

/**
 * Clears the skeletons once results are successfully loaded.
 */
function clearArticleSkeletons() {
  const container = document.querySelector(LISTING_CONTAINER_SELECTOR);
  if (!container) {
    return;
  }

  clearSkeletons(container);
}

/**
 * Subscriptions
 */
renderSkeletons$.subscribe(renderBlogArticleCardSkeletons);
onSuccesedArticleSearchResults$.subscribe(clearArticleSkeletons);
